import { convertISODateTimeHumanized, formatDateTimeShort } from "@entrilia/shared/utilities/dateUtils";

export const formatLogTimestamp = (isoDateString: string) =>
  convertISODateTimeHumanized(isoDateString, { thresholdMinutes: 10 }, formatDateTimeShort);
